import React from 'react';

import AuthenticationService from '../../backend/AuthenticationService';
import { translate } from "react-i18next";
import {Form, Row, Col} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import '../App.css';


class EventUserInfo extends React.Component {
   
    constructor(props) {
        super(props);
        this.onChangeLogin = this.onChangeLogin.bind(this);

        this.state = {
            user: {username:'', 
            email:'', 
            id:'',
            noLogin:''}
        };

        this.onInputChange = this.onInputChange.bind(this);
    }

    async componentDidMount() {
        if(AuthenticationService.isUserLoggedIn()){
           let user =  AuthenticationService.getLoggedUser();  
           if(user != null){
            let oldUser = this.state.user;
            const newUser = {
             ...oldUser,
               username: user.name,
               email: user.email,
               id: user.id
             };
             this.props.updateModel("eventAddUser",newUser);
             this.setState({
             user: newUser
             });
           }

        }
    }

    onInputChange(e) {
        const { name: fieldName, value: fieldValue } = e.target;
        let oldUser = this.state.user;

        const newUser = {
        ...oldUser,
        [fieldName]: fieldValue
        };
        this.props.updateModel("eventAddUser", newUser);
        this.setState({
          user: newUser
        });
    }

    onChangeLogin() {
        let oldState = this.state;
        let oldNoLogin = oldState.noLogin;
        this.setState({
            ...oldState,
            noLogin: !oldNoLogin
        })
    }
   
    render() {
        const { t } = this.props;
        const {user:{  username, email, id,  noLogin }} = this.state;
        
        return (
            <div className="col-md-12 " >
                  
                   { (!noLogin) ?
                      <form  >
                         <Row  className="mt-3">
                            <Col lg={12} md={12}>
                                <p >{(id > 0)? t("angemeldet"):t( "ohneAnmeldung")}</p>
                            </Col>
                            <Col lg={5} md={5}>
                                <Form.Control  value={username} 
                                    name="username" 
                                    onChange={this.onInputChange} 
                                    placeholder={t("yourName")} 
                                    disabled={id > 0}
                                    maxLength={120}
                                    />
                                    
                            </Col>
                            <Col lg={5} md={5}>
                                <Form.Control  value={email} 
                                    name="email" 
                                    onChange={this.onInputChange} 
                                    placeholder={t("yourEmail")} 
                                    disabled={id > 0}
                                    maxLength={250}
                                    />
                            </Col>
                        </Row>
                        { !(id > 0) ?
                        <div >
                            <Row>
                                <Col lg={12} md={12}>
                                    <Form.Text className="text-muted">{(id > 0)?  "": t("angemeldenBenutzer")}</Form.Text>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12} md={12} className="mt-2 mb-2">
                                <div className="hr-sect">{t("oder")}</div>
                                </Col>
                            </Row>
                            <Row >
                            
                                <Col md="auto">
                                    <p >{t("mitKonto")}</p>
                                </Col>
                                <Col md="auto">
                                <Link to="/loginPage/eventAdd" variant="primary">{t("anmelden")}</Link>
                                </Col>
                                
                            </Row>
                        </div>
                        :
                        <div></div>
                        }
                        
                      </form>
                      :
                      <form name="form" >
                        <Row  className="mt-3">
                            <Col lg={5} md={5}>
                                <Form.Text >{t("angemeldenBenutzer")}</Form.Text>
                            </Col>
                        </Row>
                        
                      </form>
                      }
                   
            </div>
        );
    }
}

export default translate("translations")(EventUserInfo);


